import { useRootStore } from "../RootStateContext";

export const useActionListStore = () => {
  const rootStore = useRootStore();
  if (!rootStore?.actionListStore) {
    throw new Error('actionListStore store should be defined');
  }
  return rootStore.actionListStore;
}